<template>
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      stroke="currentColor"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      stroke-linecap="square"
    >
      <line x1="0.5" y1="0.5" x2="15.5" y2="15.5" />
      <line x1="15.5" y1="0.5" x2="0.5" y2="15.5" />
    </g>
  </svg>
</template>

<script>
export default {}
</script>